module.exports = __webpack_public_path__ + "img/logo-dark.690cc5bf.png";